import { render, staticRenderFns } from "./LanguagePage.vue?vue&type=template&id=39340106&scoped=true&"
import script from "./LanguagePage.vue?vue&type=script&lang=js&"
export * from "./LanguagePage.vue?vue&type=script&lang=js&"
import style0 from "./LanguagePage.vue?vue&type=style&index=0&id=39340106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39340106",
  null
  
)

export default component.exports